export enum SearchKeys {
  rotorId = 'rotorId',
  typeName = 'typeName',
  operatorName = 'operatorName',
  batchId = 'batchId',
  projectNo = 'projectNo',
  timestamp = 'timestamp',
  machineName = 'machineName',
  machineSerial = 'machineSerial',
  inTolerance = 'inTolerance',
}
